class AlertService {

    static success(message) {
        var el = document.getElementById('alert');
        el.style.display = 'block';
        el.innerText = message;
        el.classList.add('notification');
        el.classList.add('notificationSuccess');

        el.addEventListener('webkitAnimationEnd', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationSuccess');
            el.style.display = 'none';
        });
        el.addEventListener('msAnimationEnd', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationSuccess');
            el.style.display = 'none';
        });

        el.addEventListener('animationend', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationSuccess');
            el.style.display = 'none';
        });

    }

    static error(message) {
        var el = document.getElementById('alert');
        el.style.display = 'block';
        el.innerText = message;

        el.classList.add('notification');
        el.classList.add('notificationError');

        el.addEventListener('webkitAnimationEnd', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationError');
            el.style.display = 'none';
        });
        el.addEventListener('msAnimationEnd', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationError');
            el.style.display = 'none';
        });

        el.addEventListener('animationend', function(event) {
            el.classList.remove('notification');
            el.classList.remove('notificationError');
            el.style.display = 'none';
        });
    }

}

export default AlertService